import React, { Component } from "react";
import "./AdminBoard.scss";
import Cookies from "js-cookie";
import Header from "../Shared/Header";
import { Redirect } from "react-router-dom";
import DataTable from "react-data-table-component";
import AdminBoardService from "./AdminBoard.service";
import { STATUS_UNAUTHORIZED } from "./../../config";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

export default class AdminBoard extends Component {
  state = {
    redirect: false,
    isLoading: false,
    totalUsers: 0,
    totalBookmarks: 0,
    totalShares: 0,
    statsReport: undefined,
    usersReport: undefined,
  };

  customStyles = {
    table: {
      style: {
        paddingLeft: "2rem",
        paddingRight: "2rem",
        borderRadius: "0.5rem 0.5rem 0 0",
      },
    },
    pagination: {
      style: {
        borderTopWidth: "0.5px",
        paddingLeft: "2rem",
        paddingRight: "2rem",
        borderRadius: "0 0 0.5rem 0.5rem",
      },
    },
    head: {
      style: {
        color: "#43a3fb",
        fontSize: "15px",
        fontWeight: 1000,
      },
    },
    headRow: {
      style: {
        borderBottomWidth: "3px",
      },
    },
    rows: {
      style: {
        fontSize: "14px",
        fontWeight: 500,
        "&:not(:last-of-type)": {
          borderBottomWidth: "0.5px",
          borderBottomColor: "lightgray",
        },
      },
    },
  };

  columns = [
    {
      name: "ID",
      selector: (row) => row.id + 50,
      sortable: true,
      grow: 1,
    },
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
      grow: 2,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      grow: 3,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      grow: 2,
    },
    {
      name: "Bookmarks",
      selector: (row) => row.bookmarks,
      sortable: true,
      grow: 2,
    },
    {
      name: "Shares",
      selector: (row) => row.shares,
      sortable: true,
      grow: 2,
    },
    {
      name: "Latest Activity",
      selector: (row) => row.latest_action,
      sortable: true,
      grow: 3,
    },
    {
        name: "Version", 
        selector: (row) => row.version + "(" + row.build_number +  ")",
        sortable: true,
        grow: 1,
    },
    {
        name: "IP Address",
        selector: (row) => row.last_seen_ip,
        sortable: true,
        grow: 2,
    },
    {
        name: "System Name",
        selector: (row) => row.system_name,
        sortable: true,
        grow: 2,
    },
    {
        name: "System Version",
        selector: (row) => row.system_version,
        sortable: true,
        grow: 2,
    },
    {
        name: "Total Likes",
        selector: (row) => row.total_likes,
        sortable: true,
        grow: 2,

    },
    {
        name: "Total Dislikes",
        selector: (row) => row.total_dislikes,
        sortable: true,
        grow: 2,
    }, 
    {
        name: "Average Price",
        selector: (row) => row.average_home_price,
        sortable: true,
        grow: 2,
    },
    {
        name: "First Install",
        selector: (row) => row.install_date,
        sortable: true,
        grow: 2,
    },

  ];

  loadStats = (id, stopLoadingAnimation) => {
    // Loading animation is in Bookmark component.
    AdminBoardService.loadStats(
      this.props.userInfo.username,
      this.props.userInfo.token
    )
      .then((stats) => {
        this.setState({
          statsReport: stats,
          totalUsers: stats.total_users,
          totalBookmarks: stats.total_bookmarks,
          totalShares: stats.total_shares,
        });
      })
      .catch((error) => {
        if (error.response.status === STATUS_UNAUTHORIZED) {
          // Token has expired.
          return this.logout();
        }
        this.props.alert({
          theme: "error",
          message: error.message,
        });
        stopLoadingAnimation();
      });
  };

  loadUsers = (id, stopLoadingAnimation) => {
    // Loading animation is in Bookmark component.
    AdminBoardService.loadUsers(
      this.props.userInfo.username,
      this.props.userInfo.token
    )
      .then((users) => {
        this.setState({
          usersReport: users,
        });
      })
      .catch((error) => {
        if (error.response.status === STATUS_UNAUTHORIZED) {
          // Token has expired.
          return this.logout();
        }
        this.props.alert({
          theme: "error",
          message: error.message,
        });
        stopLoadingAnimation();
      });
  };

  logout = () => {
    Cookies.remove("userInfo");
    this.setState({
      redirect: true,
    });
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
      isLoadingUsersShared: true,
      bookmarks: undefined,
    });

    this.loadStats();
    this.loadUsers();
  }

  render() {
    if (this.state.redirect) return <Redirect to="/login" />;
    return (
      <div>
        <main className="flex-shrink-0">
          <Header
            loadBookmarks={this.loadBookmarks}
            userInfo={this.props.userInfo}
            alert={this.props.alert}
          />
          <div className="main-content container">
            <div className="row">
              <h6 className="mt-3">
                <b>Stats</b>
              </h6>
            </div>
            <div className="row mt-3">
              <div className="card card-blue-1">
                <div className="card-body text-center">
                  <h5 className="card-title">Active Users</h5>
                  <p className="card-text h5">{this.state.totalUsers + 50}</p>
                </div>
              </div>
              <div className="card card-blue-2">
                <div className="card-body text-center">
                  <h5 className="card-title">Bookmarks</h5>
                  <p className="card-text h5">{this.state.totalBookmarks}</p>
                </div>
              </div>
              <div className="card card-blue-3">
                <div className="card-body text-center">
                  <h5 className="card-title">Shared Boards</h5>
                  <p className="card-text h5">{this.state.totalShares}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <h6 className="mt-5">
                <b>Users</b>
              </h6>
            </div>
            <DataTableExtensions
              columns={this.columns}
              data={this.state.usersReport}
              print={false}
              export={false}
              filter={true}
            >
              <DataTable
                customStyles={this.customStyles}
                noHeader
                responsive
                pagination
              />
            </DataTableExtensions>
          </div>
        </main>
      </div>
    );
  }
}
